/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FavritApp } from './FavritApp';
import {
    FavritAppFromJSON,
    FavritAppFromJSONTyped,
    FavritAppToJSON,
    FavritAppToJSONTyped,
} from './FavritApp';

/**
 * 
 * @export
 * @interface AppEnablementDto
 */
export interface AppEnablementDto {
    /**
     * 
     * @type {FavritApp}
     * @memberof AppEnablementDto
     */
    app: FavritApp;
    /**
     * 
     * @type {boolean}
     * @memberof AppEnablementDto
     */
    isEnabled: boolean;
}



/**
 * Check if a given object implements the AppEnablementDto interface.
 */
export function instanceOfAppEnablementDto(value: object): value is AppEnablementDto {
    if (!('app' in value) || value['app'] === undefined) return false;
    if (!('isEnabled' in value) || value['isEnabled'] === undefined) return false;
    return true;
}

export function AppEnablementDtoFromJSON(json: any): AppEnablementDto {
    return AppEnablementDtoFromJSONTyped(json, false);
}

export function AppEnablementDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppEnablementDto {
    if (json == null) {
        return json;
    }
    return {
        
        'app': FavritAppFromJSON(json['app']),
        'isEnabled': json['isEnabled'],
    };
}

export function AppEnablementDtoToJSON(json: any): AppEnablementDto {
    return AppEnablementDtoToJSONTyped(json, false);
}

export function AppEnablementDtoToJSONTyped(value?: AppEnablementDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'app': FavritAppToJSON(value['app']),
        'isEnabled': value['isEnabled'],
    };
}

